// Ancho y fuente reales del contenedor, usados para dimensionar columnas.
import { useLayoutEffect, useRef, useState } from "react";

export default function useTableContainerMetrics() {
  const containerRef = useRef(null);
  const [metrics, setMetrics] = useState({ width: 0, font: "14px sans-serif" });

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container || typeof window === "undefined") return undefined;
    let animationFrameId = null;

    const updateMetrics = () => {
      const computedStyle = window.getComputedStyle(container);
      const font =
        computedStyle.font ||
        `${computedStyle.fontSize || "14px"} ${
          computedStyle.fontFamily || "sans-serif"
        }`;
      const width = Math.max(0, Math.floor(container.clientWidth) - 2);

      setMetrics((current) =>
        current.width === width && current.font === font
          ? current
          : { width, font },
      );
    };
    const scheduleMetricsUpdate = () => {
      if (animationFrameId !== null) return;

      // ResizeObserver no debe modificar el elemento observado en su mismo ciclo.
      animationFrameId = window.requestAnimationFrame(() => {
        animationFrameId = null;
        updateMetrics();
      });
    };
    const cancelScheduledUpdate = () => {
      if (animationFrameId === null) return;

      window.cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    };

    updateMetrics();
    const ResizeObserverImplementation = window.ResizeObserver;
    if (ResizeObserverImplementation) {
      const observer = new ResizeObserverImplementation(scheduleMetricsUpdate);
      observer.observe(container);
      return () => {
        observer.disconnect();
        cancelScheduledUpdate();
      };
    }

    window.addEventListener("resize", scheduleMetricsUpdate);
    return () => {
      window.removeEventListener("resize", scheduleMetricsUpdate);
      cancelScheduledUpdate();
    };
  }, []);

  return { containerRef, ...metrics };
}
